import {
    useEffect,
    useState,
} from 'react';

type Props = {

    category?: any;

    onClose: () => void;

    onSave: (
        data: any
    ) => void;

};

export default function BlogCategoryModal({

                                              category,

                                              onClose,

                                              onSave,

                                          }: Props)
{
    const [
        name,
        setName,
    ] = useState('');

    const [
        active,
        setActive,
    ] = useState(true);

    useEffect(() => {

        if (
            category
        )
        {
            setName(
                category.name
            );

            setActive(
                category.is_active
            );
        }
        else
        {
            setName('');

            setActive(
                true
            );
        }

    }, [
        category
    ]);

    const handleSubmit = (
        e: React.FormEvent
    ) =>
    {
        e.preventDefault();

        onSave({

            name,

            is_active:
            active,

        });
    };

    return (

        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >

                <h2>

                    {

                        category

                            ?

                            'Edit Blog Category'

                            :

                            'Add Blog Category'

                    }

                </h2>

                <form
                    className="modal-form"
                    onSubmit={handleSubmit}
                >

                    <label>

                        Name

                    </label>

                    <input

                        type="text"

                        value={name}

                        onChange={(e) =>
                            setName(
                                e.target.value
                            )
                        }

                        required

                    />

                    <label>

                        Status

                    </label>

                    <select

                        value={
                            active
                                ? '1'
                                : '0'
                        }

                        onChange={(e) =>
                            setActive(
                                e.target.value === '1'
                            )
                        }

                    >

                        <option value="1">

                            Active

                        </option>

                        <option value="0">

                            Inactive

                        </option>

                    </select>

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={onClose}
                            >

                                Cancel

                            </button>

                        </div>

                        <div className="right-actions">

                            <button
                                type="submit"
                                className="action-btn"
                            >

                                Save

                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>

    );
}
